<template>
    <div class="four-cards-container">
      <!-- PC端显示 -->
      <div class="cards-wrapper" v-if="!isMobile">
        <ImageTextCard

          v-for="(card, index) in cards"
          :key="index"
          :image-url="card.pc_pic"
          :title="card.pic_title"
          :content="card.pic_content"
          :url="card.href"
          :alt="card.pc_pic_alt"
        />
      </div>
  
      <!-- 移动端轮播 -->
      <!-- <div class="mobile-carousel" v-else ref="carouselRef">
        <div 
          class="carousel-wrapper"
          :style="carouselStyle"
          @touchstart="touchStart"
          @touchmove="touchMove"
          @touchend="touchEnd"
        >
          <div 
            v-for="(card, index) in cards"
            :key="index"
            class="carousel-item"
            :class="{ 'active': currentIndex === index }"
          >
            <ImageTextCard
              @click="handleClick(card.href)"
              :image-url="card.pc_pic"
              :title="card.pic_title"
              :content="card.pic_content"
            />
            
          </div>
        </div> -->
        <!-- 指示器 -->
        <!-- <div class="carousel-indicators">
          <span 
            v-for="(_, index) in cards" 
            :key="index"
            :class="{ 'active': currentIndex === index }"
            @click="setCurrentIndex(index)"
          ></span>
        </div>
      </div> -->
      <div class="mobile-carousel" v-else>
        <swiper :slides-per-view="1.2" :space-between="15" @slideChange="onSlideChange" :loop="false" ref="carouselRef">
          <swiper-slide v-for="(card, index) in cards" :key="index">
            <ImageTextCard
              class="pointer"
              :image-url="card.pc_pic"
              :title="card.pic_title"
              :content="card.pic_content"
              :url="card.href"
              :alt="card.pc_pic_alt"
            />
          </swiper-slide>
        </swiper>
        <!-- 指示器 -->
        <div class="carousel-indicators">
          <span 
            v-for="(_, index) in cards" 
            :key="index"
            :class="{ 'active': currentIndex === index }"
            @click="setCurrentIndex(index)"
          ></span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import { ref, computed } from 'vue';
    import ImageTextCard from '../common/ImageTextCard.vue';
    import { homeApi } from '@/api/home'; 
    import { onMounted } from 'vue';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/swiper-bundle.css'; // 引入 Swiper 样式
    export default {
      components: {
        ImageTextCard,
        Swiper,
        SwiperSlide
      },
      data() {
        return {
            cards: [
          //   {
          //     imageUrl: '/src/assets/images/fv/c1.png',
          //     title: '创新科技',
          //     content: '引领行业发展，创造无限可能'
          //   },
          //   {
          //     imageUrl: '/src/assets/images/fv/c2.png',
          //     title: '智能解决方案',
          //     content: '为企业提供全方位的智能化服务'
          //   },
          //   {
          //     imageUrl: '/src/assets/images/fv/c3.png',
          //     title: '数字化转型',
          //     content: '助力企业实现数字化升级'
          //   },
          //   {
          //     imageUrl: '/src/assets/images/fv/c4.png',
          //     title: '全球服务',
          //     content: '提供全球化的专业服务支持'
          //   }
          ],
          isMobile: false,
          currentIndex: 0,
          carouselRef: null,
          startX: 0,
          currentTranslate: 0,
          scrollPositions: {} 
        };
      },
      computed: {
        carouselStyle() {
          return {
            transform: `translateX(${-this.currentIndex * 95 + this.currentTranslate}%)`,
            transition: this.currentTranslate ? 'none' : 'transform 0.3s ease'
          };
        }
      },
      methods: {
        onSlideChange(swiper) {
        this.currentIndex = swiper.activeIndex; // 更新当前索引
        },
        setCurrentIndex(index) {
          this.currentIndex = index; // 设置当前索引
        },
        cacheScrollPositions() {
          const newFeaturesElement = document.getElementById('new_features');
          const applicationScenariosElement = document.getElementById('application_scenarios');

          if (newFeaturesElement) {
            const rect = newFeaturesElement.getBoundingClientRect();
            this.scrollPositions.newFeaturesTop = rect.top + window.scrollY;
          }

          if (applicationScenariosElement) {
            const rect = applicationScenariosElement.getBoundingClientRect();
            this.scrollPositions.applicationScenariosTop = rect.top + window.scrollY;
          }

          // 将位置存入缓存（例如，localStorage）
          localStorage.setItem('scrollPositions', JSON.stringify(this.scrollPositions));
        },
        toUrl(url){
          console.log('url',url)
          if (url!='') {
            window.location.href = url; // 只有在 url 不为空时才跳转
          } else {
            console.log('只做展示'); // 可选：记录警告
          }
        },
        async fetchCards() {
          const response = await homeApi.getAppScenarionList();
          this.cards = response.data;
          // 在获取数据后访问 DOM
          // this.$nextTick(() => {
          //   console.log('this.$refs.carouselRef',this.$refs)
          //   if (this.$refs.carouselRef) {
          //     const elements = this.$refs.carouselRef.querySelectorAll('.some-class');
          //     console.log(elements);
          //   } else {
          //     console.error('carouselRef 是未定义的');
          //   }
          // });
        },
        checkMobile() {
          this.isMobile = window.innerWidth <= 768;
        },
        setCurrentIndex(index) {
          this.currentIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        },
        touchStart(e) {
          this.startX = e.touches[0].clientX;
          this.currentTranslate = 0;
        },
        touchMove(e) {
          const currentX = e.touches[0].clientX;
          const diff = currentX - this.startX;
          const percentMove = (diff / this.carouselRef.offsetWidth) * 100;
    
          if (
            (this.currentIndex === 0 && diff > 0) ||
            (this.currentIndex === this.cards.length - 1 && diff < 0)
          ) {
            this.currentTranslate = percentMove * 0.2;
          } else {
            this.currentTranslate = percentMove;
          }
        },
        touchEnd(e) {
          const minSwipeDistance = 50;
          const diff = e.changedTouches[0].clientX - this.startX;
    
          if (Math.abs(diff) > minSwipeDistance) {
            if (diff > 0 && this.currentIndex > 0) {
              this.currentIndex--;
            } else if (diff < 0 && this.currentIndex < this.cards.length - 1) {
              this.currentIndex++;
            }
          }
    
          this.currentTranslate = 0;
        }
      },
      mounted() {
        this.checkMobile();
        this.fetchCards();
        window.addEventListener('resize', this.checkMobile);
      },
      unmounted() {
        window.removeEventListener('resize', this.checkMobile);
      }
    };
    </script>
  
  <style scoped>
  .four-cards-container {
    width:1366px;
    max-width: 1680px;
    margin: 0 auto;
    overflow: hidden;
    margin-bottom: 53px;
  }
  
  .cards-wrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px;
  }

  /* 移动端轮播样式 */
  .mobile-carousel {
    width: 100%;
    position: relative;
    padding: 0 30px;
  }
  
  .carousel-wrapper {
    display: flex;
    width: 100%;
    will-change: transform;
  }
  
  .carousel-item {
    flex: 0 0 95%; /* 显示一个完整的卡片和一部分下一个卡片 */
    padding-right: 15px;
  }
  
  /* 指示器样式 */
  .carousel-indicators {
    display: flex;
    justify-content: center;
    gap: 8px;
    align-items: center;
    height: 25px;
  }
  
  .carousel-indicators span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #ddd;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .carousel-indicators span.active {
    background-color: #333;
    transform: scale(1.2);
  }
  @media (min-width: 768px) and (max-width: 1366px) {
    .four-cards-container {
      width:90%;
    }
  }
  @media screen and (max-width: 768px) {
    .cards-wrapper {
      display: none;
    }
    .mobile-carousel{
      padding: 0;
    }
    .four-cards-container {
      width:90%;
      padding: 0;
      margin-bottom: 20px;
    }
  }
  </style>